import { useCallback, useEffect, useState } from 'react';

import { getRouteRunId } from './components/workflowShared';
import BlockchainAuditPage from './pages/BlockchainAuditPage';
import LandingPage from './pages/LandingPage';
import WebPentestPage from './pages/WebPentestPage';
import RunPage from './run/RunPage';

const BLOCKCHAIN_AUDIT_PATH = '/blockchain-audit';
const WEB_PENTEST_PATH = '/web-pentest';

const isBlockchainAuditPath = (pathname: string): boolean => {
  return pathname === BLOCKCHAIN_AUDIT_PATH || pathname === `${BLOCKCHAIN_AUDIT_PATH}/`;
};

const isWebPentestPath = (pathname: string): boolean => {
  return pathname === WEB_PENTEST_PATH || pathname === `${WEB_PENTEST_PATH}/`;
};

const hasGitHubCallbackParams = (): boolean => {
  const params = new URLSearchParams(window.location.search);

  return params.has('github_session') || params.has('github_error') || params.has('installation_id');
};

function App() {
  const [currentPath, setCurrentPath] = useState(() => window.location.pathname);
  const routeRunId = getRouteRunId(currentPath);
  const isBlockchainAuditRoute = isBlockchainAuditPath(currentPath);
  const isWebPentestRoute = isWebPentestPath(currentPath);

  const syncCurrentPath = useCallback(() => {
    setCurrentPath(window.location.pathname);
  }, []);

  useEffect(() => {
    window.addEventListener('popstate', syncCurrentPath);

    return () => window.removeEventListener('popstate', syncCurrentPath);
  }, [syncCurrentPath]);

  useEffect(() => {
    if (!hasGitHubCallbackParams() || routeRunId || isBlockchainAuditPath(currentPath) || isWebPentestPath(currentPath)) {
      return;
    }

    const nextUrl = `${BLOCKCHAIN_AUDIT_PATH}${window.location.search}${window.location.hash}`;

    window.history.replaceState({}, document.title, nextUrl);
    syncCurrentPath();
  }, [currentPath, routeRunId, syncCurrentPath]);

  const selectSmartContractScan = useCallback(() => {
    if (!isBlockchainAuditPath(window.location.pathname)) {
      window.history.pushState({}, document.title, BLOCKCHAIN_AUDIT_PATH);
      syncCurrentPath();
    }
  }, [syncCurrentPath]);

  const selectWebPentestScan = useCallback(() => {
    if (!isWebPentestPath(window.location.pathname)) {
      window.history.pushState({}, document.title, WEB_PENTEST_PATH);
      syncCurrentPath();
    }
  }, [syncCurrentPath]);

  if (routeRunId) {
    return <RunPage runId={routeRunId} />;
  }

  if (isBlockchainAuditRoute) {
    return <BlockchainAuditPage onNavigate={syncCurrentPath} />;
  }

  if (isWebPentestRoute) {
    return <WebPentestPage onNavigate={syncCurrentPath} />;
  }

  return (
    <div className="app-shell landing-shell">
      <LandingPage
        onSelectSmartContract={selectSmartContractScan}
        onSelectWebPentest={selectWebPentestScan}
      />
    </div>
  );
}

export default App;
